import styles from './styles.module.scss';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Board } from '../../../../../components/Board';
import { useNavigate } from 'react-router-dom';
import { verifyRoutePermissions } from '../../../../../globalFunctions';
import { NavButton } from '../../../../../components/NavButton';
export const LogicManagerLogoRoute = () => {
    
    const [logo, setLogo] = useState<any>(null); // Inicialize como null
    const navigate = useNavigate()
    const [user,setUserAuth] = useState<any>(null)
    useEffect(() => {
        fetchLogo();
    }, []);


    const fetchLogo = async () => {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getLogo`);
        setLogo(response.data.logo);
        console.log(response.data.logo)
    };

    const updateLogo = async () => {
        console.log(logo)
        getBase64(logo, (result) => {
             axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/updateLogo`,{logo: result});
            setLogo(result)
        })

    };



    const getBase64 = async(file,cb) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    useEffect(() => {
        const user = verifyRoutePermissions(
            ['auth', 'email.verified', 'not.pending.update', 'logicmanager.admin'],
            navigate
        );

        if (typeof user === 'object') {
            setUserAuth(user);
        }
    }, []);

    const goBackwards = () => {     
        navigate('/manager');       
};

    return (

<div className={styles.wrapper}>
<Board wrapperClass={styles.board}>

        <div className={styles.container}>
            <h1 className={styles.titulo}>Logo Website</h1>
                <img width={"200px"} src={logo} alt="Logo do website" />
                <br></br>
                <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setLogo(e.target.files && e.target.files[0])} // Define a imagem selecionada
                />
         <button onClick={updateLogo} style={{ backgroundColor: 'green', color: 'white' }}>Adicionar Logo</button>
           
        </div>
                    </Board>
                    <NavButton
                            direction='left'
                            style={{ left: '0.4vw', top: '2vw', zIndex: '20' }}
                            onClick={goBackwards}
                            /> 
                    </div>
    );
};

